import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../../shared';
import { SearchFilterContainerModel} from '../../../../../../models';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})

export class FinancialSearchFilterService extends BaseApiTemplateService<SearchFilterContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/public-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/public-ep';
    this.httpClient = http;
  }

  getFilterByLabelHdrGuid(labelHdrGuid: string,  visa: ApiVisa): Observable<BasicApiResponseModel<SearchFilterContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<SearchFilterContainerModel>>(this.apiUrl + '/' + labelHdrGuid, this.getHttpHeader(visa));
  }

  getSortedFilterByLabelHdrGuid(labelHdrGuid: string,  visa: ApiVisa): Observable<BasicApiResponseModel<SearchFilterContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/sorted/public-ep';
    if (visa.api_domain_url) {
         url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/sorted/public-ep';
    }
    return this.httpClient.get<BasicApiResponseModel<SearchFilterContainerModel>>(url + '/' + labelHdrGuid, this.getHttpHeader(visa));
  }

  getSortedFilterByLabelHdrGuids(labelHdrGuids: any,  visa: ApiVisa): Observable<BasicApiResponseModel<SearchFilterContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/sorted/public-ep';
    if (visa.api_domain_url) {
         url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/sorted/public-ep';
    }
    return this.httpClient.get<BasicApiResponseModel<SearchFilterContainerModel>>(url + '?hdrGuids=' + `${labelHdrGuids}`, this.getHttpHeader(visa));
  }
}
